import React from 'react';
import { Link } from 'react-router-dom';

const KnowledgeBasePage = () => {
  return (
    <div className="container mx-auto px-4 py-12">
      <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-8">
        Knowledge Base
      </h1>

      <div className="mb-12">
        <div className="max-w-2xl">
          <h2 className="text-2xl font-semibold mb-4">
            Find the answers you need
          </h2>
          <p className="text-gray-600 dark:text-gray-300 mb-6">
            Browse our comprehensive knowledge base for detailed guides, troubleshooting tips, 
            and best practices for using Agent Nexus.
          </p>
        </div>

        <div className="relative mt-8 mb-12">
          <input
            type="text"
            placeholder="Search the knowledge base..."
            className="w-full md:w-2/3 px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
          />
          <button className="absolute right-2 top-2 p-2 text-gray-500 dark:text-gray-400">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </button>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-sm">
            <h3 className="text-xl font-semibold mb-4">Getting Started</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/knowledge-base/quick-start" className="text-primary-600 dark:text-primary-400 hover:underline">
                  Quick Start Guide
                </Link>
              </li>
            </ul>
          </div>

          <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-sm">
            <h3 className="text-xl font-semibold mb-4">Popular Topics</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/knowledge-base/automation" className="text-primary-600 dark:text-primary-400 hover:underline">
                  Automation Workflows
                </Link>
              </li>
              <li>
                <Link to="/knowledge-base/integration" className="text-primary-600 dark:text-primary-400 hover:underline">
                  Integration Guide
                </Link>
              </li>
              <li>
                <Link to="/knowledge-base/security" className="text-primary-600 dark:text-primary-400 hover:underline">
                  Security Best Practices
                </Link>
              </li>
            </ul>
          </div>

          <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-sm">
            <h3 className="text-xl font-semibold mb-4">Troubleshooting</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/knowledge-base/common-issues" className="text-primary-600 dark:text-primary-400 hover:underline">
                  Common Issues
                </Link>
              </li>
              <li>
                <Link to="/knowledge-base/error-codes" className="text-primary-600 dark:text-primary-400 hover:underline">
                  Error Code Reference
                </Link>
              </li>
              <li>
                <Link to="/knowledge-base/faq" className="text-primary-600 dark:text-primary-400 hover:underline">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="bg-gray-50 dark:bg-gray-900 p-8 rounded-lg">
        <h2 className="text-2xl font-semibold mb-4">
          Need More Help?
        </h2>
        <p className="text-gray-600 dark:text-gray-300 mb-6">
          Can't find what you're looking for? Our support team is here to help.
        </p>
        <div className="flex space-x-4">
          <Link to="/community" className="btn-outline">
            Visit Community Forum
          </Link>
          <Link to="/contact" className="btn-primary">
            Contact Support
          </Link>
        </div>
      </div>
    </div>
  );
};

export default KnowledgeBasePage; 